/* eslint-disable camelcase */
import wilayasData from './wilayasAndCommunesdata/wilayas.json'
import communesData from './wilayasAndCommunesdata/communes.json'
import { getDairasOfWilayasApi } from '../modules/Intervenant/api'

export const getWilayas = () =>
document.getElementsByTagName('html')[0].getAttribute('dir') === "ltr"
? 
  wilayasData.map(({ name, id }) => ({ label: name, id }))
: 
  wilayasData.map(({name_ar, id }) => ({label: name_ar, id }))
  

export const getArabicWilayas = () => 
  wilayasData.map(({name_ar, id }) => ({label: name_ar, id }))

export const getCommunes = () => 
  communesData.map(({ name, id }) => ({label: name, id}))

export const getArabicCommunes = () => 
  communesData.map(({ name_ar, id }) => ({label: name_ar, id }))

export const getIntervenantWilayas = (name, wilayaId) => (({ label: name, wilayaId}))

export const getCommunesOfWilayas = (selectedWilayas) => {
  return communesData
    .filter((commune) =>
      selectedWilayas.some(
        (selectedWilaya) => selectedWilaya.id === commune.idWilayaParent,
      ),
    )
    .map(({ id, name }) => ({
      id,
      label: name,
    }))
}

export const getArabicCommunesofWilayas = (selectedWilayas) => {
  return communesData 
    .filter((commune) => 
      selectedWilayas.some(
        (selectedWilaya) => selectedWilaya.id === commune.idWilayaParent,
      ),
    )
    .map(({ id, name_ar}) => ({
      id,
      label: name_ar
    }))
}

export const getWilayaLabel = (wilayaId) =>
  wilayasData.find(({ id }) => id === wilayaId)?.name || 'N/A'

export const getWilayaArabicLabel = (wilayaId) => 
  wilayasData.find(({ id }) => id === wilayaId)?.name_ar || 'N/A'

export const getChartWilayaLabel = (label) => 
  wilayasData.find(({ name }) => name === label)?.name || 'N/A'

export const getChartWilayaArabicLabel = (label) =>
  wilayasData.find(({name}) => name === label )?.name_ar || 'N/A'

export const getCommuneLabel = (communeId) =>
  communesData.find(({ id }) => id === communeId)?.name || 'N/A'

export const getCommuneArabicLabel = (communeId) => 
  communesData.find(({ id }) => id === communeId)?.name_ar || 'N/A'

export const getLocalisation = ({ communeId, wilayaId }) =>
  `${getWilayaLabel(wilayaId)} > ${getCommuneLabel(communeId)}`.toLowerCase()

export const getLocalisationAr = ({ communeId, wilayaId }) =>
  `${wilayasData.find(({ id }) => id === wilayaId)?.name_ar || 'N/A'} < ${
    communesData.find(({ id }) => id === communeId)?.name_ar || 'N/A'
  }`
